module.exports = __webpack_public_path__ + "img/candy.e903253a.png";